import { action, atom } from "@reatom/framework";
import { OrderList } from "definitions/poizon-api";

import { DEFAULT_PAGE_SIZE } from "../constants";

export const orderListAtom = atom(new Array<OrderList>(), "orderListAtom");
export const lastOrderListAtom = atom<OrderList[]>([], "lastOrderList");
export const lastIdAtom = atom<string | undefined>(undefined, "lastIdAtom");
export const hasMoreAtom = atom((ctx) => {
  return ctx.spy(lastOrderListAtom).length === DEFAULT_PAGE_SIZE;
});

export const clearOrderListAction = action((ctx) => {
  orderListAtom(ctx, []);
  lastOrderListAtom(ctx, []);
  lastIdAtom(ctx, undefined);
}, "clearOrderListAction");
